import {addToCart} from 'cart';
import 'events';
import 'micro-conversions';
import 'utils';
import 'component/modal-trigger';
import 'component/toast';
import setupScrollAnimations from 'scroll-animation';

window.theme.cart = window.theme.cart || {};

window.theme.cart.addToCart = addToCart;

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

const logShoplabBranding = () => {
  // eslint-disable-next-line no-console
  console.log(
    '%c shoplab',
    'background:#000639;padding:20px;color:#fff;font-size:1.9em;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-weight:bold;width:400px'
  );
  // eslint-disable-next-line no-console
  console.log(
    '%c Shopify Experts \n www.shoplab.cc',
    'background:#fff;padding:0px;color:#000639;font-size:1.1em;line-height:1.2em;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-weight:bold;text-decoration:none;width:400px'
  );
};

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Dispatch custom event based on page type from body ID
 * @returns void
 */
const dispatchPageTypeEvent = () => {
  const bodyId = document.body.id;
  if (!bodyId) return;
  window.dispatchEvent(new CustomEvent(`page:${bodyId}`));
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  window.dispatchEvent(new CustomEvent('page:loaded'));
  logShoplabBranding();
  setupScrollAnimations();
  dispatchPageTypeEvent();
});
